import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Home } from 'lucide-react';

export default function NotFound() {
    return (
        <div className="flex items-center justify-center min-h-[60vh] p-8">
            <div className="text-center">
                <p className="text-8xl font-thin text-muted-foreground/50 mb-4">404</p>
                <h1 className="text-2xl font-semibold mb-2">Page not found</h1>
                <p className="text-muted-foreground mb-6">We can't find the page you're looking for.</p>
                <Button asChild>
                    <Link to="/">
                        <Home className="h-4 w-4 mr-2" />
                        Go Home
                    </Link>
                </Button>
            </div>
        </div>
    );
}
